import React from "react";
import ReactDOM from "react-dom";

//Para voltar a utilizar apenas o Bootstrap, comente as três linhas imediatamente abaixo.
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";

import App from "./App";


ReactDOM.render(<App />, document.getElementById("root"));
